var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "quick-font-settings",
    attrs: {
      "aria-labelledby": "quick-font-title"
    }
  }, [_vm._m(0), _vm.fontElements.length ? _c('div', {
    staticClass: "quick-font-list"
  }, _vm._l(_vm.fontElements, function (element) {
    return _c('div', {
      key: element.id,
      staticClass: "quick-font-row",
      attrs: {
        "data-element-id": element.id
      }
    }, [_c('div', {
      staticClass: "quick-font-identity"
    }, [_c('strong', {
      attrs: {
        "title": element.nome || _vm.typeLabel(element)
      }
    }, [_vm._v(" " + _vm._s(element.nome || _vm.typeLabel(element)) + " ")]), _c('small', [_vm._v(_vm._s(_vm.typeLabel(element)))])]), _c('div', {
      staticClass: "quick-font-control",
      attrs: {
        "role": "group",
        "aria-label": "Tamanho da fonte de ".concat(element.nome || _vm.typeLabel(element))
      }
    }, [_c('button', {
      attrs: {
        "type": "button",
        "disabled": _vm.fontSize(element) <= _vm.minSize,
        "aria-label": "Diminuir fonte de ".concat(element.nome || _vm.typeLabel(element))
      },
      on: {
        "click": function click($event) {
          return _vm.adjust(element, -_vm.step);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-minus"
    })]), _c('label', [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v("Tamanho da fonte de " + _vm._s(element.nome || _vm.typeLabel(element)))]), _c('input', {
      attrs: {
        "type": "number",
        "min": _vm.minSize,
        "max": _vm.maxSize,
        "step": _vm.step
      },
      domProps: {
        "value": _vm.fontSize(element)
      },
      on: {
        "change": function change($event) {
          return _vm.applyInput(element, $event);
        },
        "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return $event.target.blur();
        }
      }
    }), _c('span', [_vm._v("pt")])]), _c('button', {
      attrs: {
        "type": "button",
        "disabled": _vm.fontSize(element) >= _vm.maxSize,
        "aria-label": "Aumentar fonte de ".concat(element.nome || _vm.typeLabel(element))
      },
      on: {
        "click": function click($event) {
          return _vm.adjust(element, _vm.step);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus"
    })])])]);
  }), 0) : _c('div', {
    staticClass: "quick-font-empty"
  }, [_vm._v(" Adicione um texto ou campo à etiqueta para ajustar sua fonte aqui. ")])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "quick-font-heading"
  }, [_c('span', {
    staticClass: "quick-font-icon"
  }, [_c('i', {
    staticClass: "fas fa-text-height"
  })]), _c('div', [_c('strong', {
    attrs: {
      "id": "quick-font-title"
    }
  }, [_vm._v("Tamanho do texto na etiqueta")]), _c('small', [_vm._v(" Esta alteração será salva no modelo e usada na prévia, impressão teste e impressão final. ")])])]);
}];
export { render, staticRenderFns };